<template>
  <v-chip-group :value="selected" center-active show-arrows>
    <v-chip outlined :color="category.color" v-for="category in categories"
            :key="`${category.item}-${criticalEventId}`">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon left v-on="on">{{ categoriesData[category.type].icon }}</v-icon>
        </template>
        <span> {{ $vuetify.lang.t(categoriesData[category.type].text) }} </span>
      </v-tooltip>
      {{ category.item }}
    </v-chip>
  </v-chip-group>

</template>

<script>
import { CriticalDatasetLabels } from '../../enum'
import {
  mdiCellphone,
  mdiFood,
  mdiHandRight,
  mdiHumanGreeting,
  mdiSeatbelt, mdiSmoking,
  mdiTransitTransfer,
  mdiWeatherSunny
} from '@mdi/js'

export default {
  name: 'datasetChipList',
  props: {
    categories: Array,
    criticalEventId: Number
  },
  data: () => ({
    selected: -1,
    categoriesData: {
      [CriticalDatasetLabels.HUMAN]: {
        icon: mdiHumanGreeting,
        text: `$vuetify.criticalDataset.labels.${CriticalDatasetLabels.HUMAN}`
      },
      [CriticalDatasetLabels.LIGHT_CONDITIONS]: {
        icon: mdiWeatherSunny,
        text: `$vuetify.criticalDataset.labels.${CriticalDatasetLabels.LIGHT_CONDITIONS}`
      },
      [CriticalDatasetLabels.ACTIONS]: {
        icon: mdiTransitTransfer,
        text: `$vuetify.criticalDataset.labels.${CriticalDatasetLabels.ACTIONS}`
      },
      [CriticalDatasetLabels.BELT_DETECTOR]: {
        icon: mdiSeatbelt,
        text: `$vuetify.map.driverSettings.tabs.belt`
      },
      [CriticalDatasetLabels.FRAME_HANDS_DETECTOR]: {
        icon: mdiHandRight,
        text: `$vuetify.map.driverSettings.tabs.handsFrame`
      },
      [CriticalDatasetLabels.PHONE_DETECTOR]: {
        icon: mdiCellphone,
        text: `$vuetify.map.driverSettings.tabs.cellphone`
      },
      [CriticalDatasetLabels.FOOD_DETECTOR]: {
        icon: mdiFood,
        text: `$vuetify.map.driverSettings.tabs.eating`
      },
      [CriticalDatasetLabels.SMOKE_DETECTOR]: {
        icon: mdiSmoking,
        text: `$vuetify.map.driverSettings.tabs.smoking`
      }
    }
  }),
  watch: {
    criticalEventId (n) {
      // this.selected = 0
      // this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>
